(function ($) {
  $.fn.wsSizeSelection = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            this.resizeMenu();
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      // Elements
      let selectElement;
      let containerElement;

      // Variables
      // none

      let bindEvents = function () {
        selectElement.change(function () {
          build();
        });

        $(document).bind('woocommerce_update_variation_values', function () {
          build();
        });
      }

      let build = function () {
        // Create a container element for the size selection.
        if (containerElement === undefined) {
          containerElement = $('<div class="ws-size-selection">');
        } else {
          containerElement.empty();
        }

        // Loop through all the select's options and create a new element for each.
        selectElement.find('option').each((index, el) => {
          const option = $(el);
          const optionValue = option.val();
          const optionText = option.text();

          if (optionValue === '') {
            return;
          }

          const optionElement = $(`
            <div class="ws-size-selection-option" data-value="${optionValue}">
              ${optionText}
            </div>
          `);

          if (selectElement.val() === optionValue) {
            optionElement.addClass('selected');
          }

          if (option.is(':disabled')) {
            optionElement.addClass('disabled');
          } else {
            optionElement.click(function () {
              selectElement.val(optionValue);
              selectElement.trigger('change');
            })
          }

          containerElement.append(optionElement);
        })
        selectElement.after(containerElement);
      }

      let initialize = function (selectElementParameter) {
        selectElement = $(selectElementParameter);

        if (selectElement.data('ws-size-selection')) {
          console.warn('Trying to reinitialize the size selection for element. Skipping.', selectElement);
          return;
        }
        selectElement.data('ws-size-selection', this);


        // Find elements and set to variable.
        //openButtonElement = $(opt.openButton);

        build();

        bindEvents();
      }

      initialize(this);
    });
  };
})(jQuery);
